const BASE_URL = process.env.REACT_APP_API_URL;

function getToken() {
    return localStorage.getItem("d_c_c_t");
}


async function getCsrfToken() {
  const response = await fetch(`${BASE_URL}/csrf/token`, { method: "GET", credentials: "include" });
  const data = await response.json();
  return data.csrfToken;
}

export async function createQuestion(body:any) {
    try{

    const token = getToken();
    //const csrfToken = await getCsrfToken();

     const headers = {
         "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // "X-CSRF-TOKEN": csrfToken,
     };
     const response = await fetch(`${BASE_URL}/bank-questions`, {
         method: "POST",
         headers,
         body: JSON.stringify(body),
        //  credentials: "include",
     });


     const data = await response.json();
     if (!response.ok || !data.success) {
         if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
             throw new Error("Forbidden: You do not have permission to access this resource.");
         }
         //console.log("Failed to fetch");
     }
     return data;
 } catch (error: any) {
     //console.log(error);
 }
}


export async function getUserRolePermissions() {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    const userId=localStorage.getItem("userId")
    const response = await fetch(`${BASE_URL}/groups/getGroupUsers/${userId}`, {
      method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      // "X-CSRF-TOKEN": csrfToken,
    },
    // credentials: "include",
  });
  const data = await response.json();
  return data;
  } catch (error: any) {
    return { success: false, message: error.message || 'Failed to get user role permissions' };
  }
}

export async function loginUser(username: string, password: string,rememberMe: boolean) {
  try {
    console.log(username, password);


      
    
      const headers = {
          "Content-Type": "application/json"

          
      };
    //  const response = await fetch(`${BASE_URL}/auth/loginDemo`, {
     const response = await fetch(`${BASE_URL}/auth/suptech`, {

     
          method: 'POST',
          headers,
          body: JSON.stringify({ username, password ,rememberMe}),
      });

      

      if (!response.ok) {
          const errorData = await response.json();
          return { isSuccess: false, message: errorData.message || 'Login failed', failedLoginAttempts: errorData.failedLoginAttempts || 0 };
      }

      const data = await response.json();
     
      if(data.isSuccess){
          localStorage.setItem('d_c_c_t', data.data.token.accessToken);
      }
      


      
      return data;
     
     
  } catch (error: any) {
      throw new Error(error.message || 'Login failed');
  }
}


export async function submitQuestionsAndAnswers(questionAnswers: any[]) {
  try {
   
    //const csrfToken = await getCsrfToken();
    const response = await fetch(`${BASE_URL}/publicSurvey/process`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getToken()}`,
        // "X-CSRF-TOKEN": csrfToken,
      },
      // credentials: "include",
      body: JSON.stringify({ data: questionAnswers }),  
    });

   

    const result = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || result.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return result;
} catch (error: any) {
    throw new Error(error);
}
}

export async function validateToken(token: string) {
  const response = await fetch(`${BASE_URL}/auth/validate-token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  });

  if (!response.ok) {
    throw new Error('Failed to validate token');
  }

const data = await response.json();
  if(data.isSuccess){
    localStorage.setItem('d_c_c_t', data.data.token.accessToken);
  }
  return data;
}

export async function getUsers(query: string, perPage: number, pageNo: number): Promise<{ success: boolean; data?: any[], totalCount?: number, message?: string }> {
  try {
    const token = getToken();
    const response = await fetch(`${BASE_URL}/users?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
       'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      return { success: false, message: errorData.message || 'Failed to get users' };
    }

    const data = await response.json();
    return data

  } catch (error: any) {
    return { success: false, message: error.message || 'Failed to get users' };
  }
}




